import React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

// Planning to replace the other button (index.js) with this one

const Button = ({ children, color, disabled, ghost, size, ...props }) => {
  return (
    <StyledButton color={color} data-ghost={ghost} disabled={disabled} size={size} {...props}>
      {children}
    </StyledButton>
  )
}

Button.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf(['green', 'gray', 'yellow', 'black']),
  disabled: PropTypes.bool,
  ghost: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'large']),
}

Button.defaultProps = {
  color: 'yellow',
  disabled: false,
  ghost: false,
  size: 'large',
}

const StyledButton = styled.button`
  background-color: ${props => {
    if (props['data-ghost']) {
      return 'transparent'
    }
    if (props.disabled) {
      switch (props.color) {
        case 'green':
          return props.theme.color.g200
        case 'gray':
          return props.theme.color.n20
        case 'black':
          return props.theme.color.n500
        case 'yellow':
        default:
          return props.theme.color.y200
      }
    }
    switch (props.color) {
      case 'green':
        return props.theme.color.g400
      case 'gray':
        return props.theme.color.n30
      case 'black':
        return '#000'
      case 'yellow':
      default:
        return props.theme.color.y400
    }
  }};
  border: ${props => {
    if (props.disabled) {
      switch (props.color) {
        case 'green':
          return `2px solid ${props.theme.color.g200}`
        case 'gray':
          return `2px solid ${props.theme.color.n20}`
        case 'black':
          return `2px solid ${props.theme.color.n500}`
        case 'yellow':
        default:
          return `2px solid ${props.theme.color.y200}`
      }
    }
    switch (props.color) {
      case 'green':
        return `2px solid ${props.theme.color.g400}`
      case 'gray':
        return `2px solid ${props.theme.color.n30}`
      case 'black':
        return `2px solid #000`
      case 'yellow':
      default:
        return `2px solid ${props.theme.color.y400}`
    }
  }};
  color: ${props => {
    if (props['data-ghost']) {
      if (props.disabled) {
        switch (props.color) {
          case 'green':
            return props.theme.color.g200
          case 'gray':
            return props.theme.color.n70
          case 'black':
            return props.theme.color.n500
          case 'yellow':
          default:
            return props.theme.color.y200
        }
      }
      switch (props.color) {
        case 'green':
          return props.theme.color.g400
        case 'gray':
          return props.theme.color.n100
        case 'black':
          return '#000'
        case 'yellow':
        default:
          return props.theme.color.y400
      }
    }
    if (props.disabled) {
      switch (props.color) {
        case 'green':
          return props.theme.color.g50
        case 'gray':
          return props.theme.color.n100
        case 'black':
          return props.theme.color.n200
        case 'yellow':
        default:
          return props.theme.color.y600
      }
    }
    switch (props.color) {
      case 'green':
      case 'black':
        return '#fff'
      case 'gray':
        return props.theme.color.n400
      case 'yellow':
      default:
        return props.theme.color.y700
    }
  }};
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  display: block;
  font-family: 'JD Sans', sans-serif;
  font-size: 1em;
  font-weight: bold;
  line-height: 1.15;
  margin: 0;
  padding: ${props => (props.size === 'small' ? '9px 16px' : '15px 20px')};
  overflow: visible;
  text-align: center;
  text-transform: none;
  transition: all 0.2s ease;
  width: auto;

  :not(:disabled) {
    :hover,
    :active,
    :focus {
      background-color: ${props => {
        if (props['data-ghost']) {
          if (props.disabled) {
            return 'transparent'
          }
          switch (props.color) {
            case 'green':
              return props.theme.color.g400
            case 'yellow':
              return props.theme.color.y400
            case 'gray':
              return props.theme.color.n30
            case 'black':
              return '#000'
            default:
              return props.theme.color.y400
          }
        }
        switch (props.color) {
          case 'green':
            return '#2f6532'
          case 'yellow':
            return '#ffcc00'
          case 'gray':
            return '#d7d7d7'
          case 'black':
            return props.theme.color.n600
          default:
            return '#ffcc00'
        }
      }};
      border: ${props => {
        if (props['data-ghost']) {
          if (props.disabled) {
            switch (props.color) {
              case 'green':
                return `2px solid ${props.theme.color.g200}`
              case 'gray':
                return `2px solid ${props.theme.color.n20}`
              case 'black':
                return `2px solid ${props.theme.color.n500}`
              case 'yellow':
              default:
                return `2px solid ${props.theme.color.y200}`
            }
          }
          switch (props.color) {
            case 'green':
              return `2px solid ${props.theme.color.g400}`
            case 'yellow':
              return `2px solid ${props.theme.color.y400}`
            case 'gray':
              return `2px solid ${props.theme.color.n30}`
            case 'black':
              return `2px solid #000`
            default:
              return `2px solid ${props.theme.color.y400}`
          }
        }
        switch (props.color) {
          case 'green':
            return '2px solid #2f6532'
          case 'yellow':
            return '2px solid #ffcc00'
          case 'gray':
            return '2px solid #d7d7d7'
          case 'black':
            return `2px solid ${props.theme.color.n600}`
          default:
            return '2px solid #ffcc00'
        }
      }};
      color: ${props => {
        if (props.disabled) {
          switch (props.color) {
            case 'green':
              return props.theme.color.g200
            case 'gray':
              return props.theme.color.n70
            case 'black':
              return props.theme.color.n500
            case 'yellow':
            default:
              return props.theme.color.y200
          }
        }
        switch (props.color) {
          case 'green':
            return '#fff'
          case 'yellow':
            return props.theme.color.y700
          case 'gray':
            return props.theme.color.n400
          case 'black':
            return '#fff'
          default:
            return props.theme.color.y700
        }
      }};
    }
  }
`

export default Button
